import CryptoJS from 'crypto-js'

const toCreateOfferingButton = () =>  {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content',
        'event_label':  'Crear una ofrenda',
        'interaction':'true',
        'component_name': 'Crear una ofrenda',
        'element_text':  'Crear una ofrenda',
        'product': ''
      
    })
}


const toShowOfferingButton = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content',
        'event_label':  'Ver Ofrenda',
        'interaction':'true',
        'component_name': 'Ver Ofrenda',
        'element_text':  'Ver Ofrenda',
        'product': ''
      
    })
}

const toCreateOfferingButton2 = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content', 
        'event_label': 'Crea una ofrenda',
        'interaction':'true',
        'component_name': 'Crea una ofrenda',
        'element_text': 'Crea una ofrenda'
    })
}

const toContinue2 = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content', 
        'event_label': 'Continuar2',
        'interaction':'true',
        'component_name': 'Continuar',
        'element_text': 'Continuar'
    })
}

const toContinue3 = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content', 
        'event_label': 'Continuar3',
        'interaction':'true',
        'component_name': 'Continuar',
        'element_text': 'Continuar'
    })
}

const toConoceMas= () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content', 
        'event_label': 'Conoce más',
        'interaction':'true',
        'component_name': 'Conoce más',
        'element_text': 'Conoce más'
    })
}


const registerSubmit = (email: string) => {
    console.log('email:::: ', email)
    email = CryptoJS.SHA256(email).toString(CryptoJS.enc.Hex);
    //setDatalayer('Registro', email)
}

/**
 * setDatalayer
 *
 * Set datalayer
 * @param event_action
 * @param event_label
 * @param event
 * @param event_category
 */
/*function setDatalayer(event_action: string, event_label: string = 'Clic', event:string = 'GAEvent', event_category: string = 'Victoria Cempasuchil'){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, event_category, event_action, event_label});
}*/

export { toCreateOfferingButton, toShowOfferingButton, toCreateOfferingButton2, toContinue2, toContinue3, toConoceMas, registerSubmit  }
